<template>
  <el-dialog
    class="radish-dia"
    title="市场薪酬"
    top="70px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :modal="false"
    :visible.sync="salaryVisible"
  >
    <el-tabs v-model="salaryActive" style="padding-bottom:10px">
      <el-tab-pane label="职能模块薪酬" name="cate" style="height:300px;overflow:auto">
        <CategoryMoney ref="CategoryMoney" :radish="param"></CategoryMoney>
      </el-tab-pane>
      <el-tab-pane label="同职能模块人选薪酬" name="cateRadish" style="height:300px;overflow:auto">
        <div v-if="!param.职能模块">无职能模块</div>
        <RadishesMoney ref="RadishesMoney" v-else :category="param.职能模块"></RadishesMoney>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import CategoryMoney from '../components/category-money'
import RadishesMoney from '../components/radishes-money'
export default {
  components: {CategoryMoney, RadishesMoney},
  data() {
    return {
      param: {},// 行业、职能模块、职级、专业职级、细分职能、擅长方向
      salaryVisible: false,
      salaryActive: 'cate',
    }
  },
  methods: {
    open(param) {
      this.salaryActive = 'cate'
      this.param = param
      this.$nextTick(()=>{
        this.$refs.CategoryMoney && this.$refs.CategoryMoney.loadSalary()
        this.$refs.RadishesMoney && this.$refs.RadishesMoney.loadData()
      })
      this.salaryVisible = true
    }
  }
}
</script>
